<template>
    <div class="relative">
        <preloader
            v-if="isLoadingInProgress"
            class="py-8"
            :class="preloaderClass"
        />

        <p class="mt-10 text-center text-3xl font-light font-secondary" v-if="giftCards.length == 0 && !isLoadingInProgress">
            {{ __('Nie znaleziono karty upominkowej spełniającej podane kryteria') }}
        </p>

        <template v-if="giftCards.length">
            <div class="grid grid-cols-1 sm:grid-cols-2 gap-8 mt-4 md:grid-cols-4">
                <gift-card-item class="mt-2"
                    v-for="(giftCard, index) in giftCards" :key="`gift-card-${index}`"
                    :gift-card="giftCard"
                />
            </div>
        </template>

        <pagination
            v-if="giftCards.length && this.take !== null"
            :pagination="pagination"
            @paginate="loadGiftCards"
        />
    </div>
</template>

<script>
import axios from "axios";
import Preloader from "@/common/components/Preloader";
import GiftCardItem from "./Item";
import Pagination from '../Pagination';

export default {
    props: {
        take: Number|null,
        phrase: {
            type: String,
            required: false,
            default: null
        },
        autoload: {
            type: Boolean,
            required: false,
            default: true
        },
        requestOptions: Object,
    },
    components: {
        Preloader,
        GiftCardItem,
        Pagination
    },
    data: function() {
        return{
            giftCards: [],
            isLoadingInProgress: false,
            pagination: [],
            totalCount: 0
        }
    },
    methods: {
        loadGiftCards() {
            this.isLoadingInProgress = true;
            this.$giftCardBus.$emit('gift-cards-loading');

            let currentPage = this.pagination.current_page;
            let page = currentPage ? currentPage : 1;
            let params = { items_count: this.take, phrase: this.phrase }


            this.savePageInUrl(page);

            axios
                .post(route('json.gift_cards') + '?page=' + page, params)
                .then(response => {
                    this.giftCards = _.get(response, "data.data", []);
                    this.pagination = _.get(response, "data.meta", []);
                    this.$giftCardBus.$emit('gift-cards-loaded');
                    this.$emit('count-gift-cards-results', this.pagination.total);
                })
                .catch(error => {
                    console.log(error);
                })
                .then(() => {
                    this.isLoadingInProgress = false;
                });
        },
        savePageInUrl(page) {
            let url = new URL(window.location.href);

            page == 1
                ? url.searchParams.delete('options[page]')
                : url.searchParams.set('options[page]', page);

            url.search = decodeURIComponent(url.searchParams.toString());
            url = url.toString();
            window.history.replaceState({url: url}, null, url);
        }
    },
    mounted() {
        let requestPage = parseInt(_.get(this.requestOptions, 'page.0', 1));

        if(! isNaN(requestPage)) {
            this.pagination.current_page = requestPage;
        }

        if(this.autoload) {
            this.loadGiftCards();
        }
    },
    computed: {
        preloaderClass() {
            return this.giftCards.length > 0
                ? ""
                : "loading--transparent loading--block mt-12";
        }
    },
    watch: {
        options: {
            handler(val) {
                this.pagination.current_page = 1;
                this.loadGiftCards();
            },
            deep: true
        }
    },
};
</script>
